<template>
  <settings-card>
    <template v-slot:title>
      Quel objectif souhaites-tu te fixer ?
    </template>

    <!--
    <template v-slot:message v-if="messageDisplay">
      <div class="message">
        <div>
          <i class="fa-solid fa-lightbulb-exclamation-on"></i> Se fixer un objectif donne plus de chances de venir régulièrement et progresser.
          <br><i class="fa-solid fa-lightbulb-exclamation-on"></i> Trouve un ou plusieurs moments dans la semaine pour tes sessions d'anglais !
        </div>
        <div style="width: max-content" class="horizontalCenter">
          <standard-button @click="messageDisplay = false" :color-class="'olive'">Compris</standard-button>
        </div>
      </div>
    </template>
    -->
    <template v-slot:content>
      <div class="goalcontent  centercenter">
        <div class="calendar">
          <div v-for="id in [0, 1, 2, 3, 4, 5, 6]" :key="id" class="studyingDay flexwrap centercenter clickable"
               :style="{'background-color: rgba(76,76,76,0.27)':!daySelected(id)}"
               :class="{'selected' : daySelected(id)}"
               @click="toggleDay(id)"
          >
            {{dayNames(id)}}
          </div>
        </div>
        <div>
          <h2 class="paddingRound flexwrap centercenter mediumRoundAngles" >{{dayCount()}} jours / semaine</h2>
          <h3 v-if="dayCount()<2||dayCount()>4">(Nous te recommandons de choisir entre 2 et 4 jours par semaine)</h3>
        </div>
        <h3 style="font-size: 1.3em"><toggle v-model="tempProfile.reminders_ok"> Recevoir des rappels en cas d'oubli</toggle></h3>

        <standard-button id="saveProfileButton" @click="saveChanges" :inactive="saveInactive" :color-class="'olive'">Valider</standard-button>
      </div>

    </template>
  </settings-card>

</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {API_URL} from "@/App";
import axios from "axios";
import {manageUserDatas} from "@/mixins/manageUserDatas";
import SettingsCard from "@/components/settingsCard";

export default {
  name: "setgoal",

  mixins: [manageUserDatas],

  components: {
    SettingsCard,
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    Toggle: () => import(/* webpackPrefetch: true */ '@/components/toggle.vue'),
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    patchUserInfo() {
      let payload = {
        "studying_friday":this.tempProfile.studying_friday,
        "studying_monday":this.tempProfile.studying_monday,
        "studying_saturday":this.tempProfile.studying_saturday,
        "studying_sunday":this.tempProfile.studying_sunday,
        "studying_thursday":this.tempProfile.studying_thursday,
        "studying_tuesday":this.tempProfile.studying_tuesday,
        "studying_wednesday":this.tempProfile.studying_wednesday,
        "reminders_ok" : this.tempProfile.reminders_ok,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                this.update_userDatas(response.data)
              })
        }
        else {
          console.log(error)
        }
      })
      // On actualise aussi les variables dans le store
      this.saveInactive = true
    },
    changedTempProfile: function() {
      /*
      if(this.source === "guide") {
        if(this.guideTempProfile.studying_monday == this.tempProfile.studying_monday &&
            this.guideTempProfile.studying_tuesday == this.tempProfile.studying_tuesday &&
            this.guideTempProfile.studying_wednesday == this.tempProfile.studying_wednesday &&
            this.guideTempProfile.studying_thursday == this.tempProfile.studying_thursday &&
            this.guideTempProfile.studying_friday == this.tempProfile.studying_friday &&
            this.guideTempProfile.studying_saturday == this.tempProfile.studying_saturday &&
            this.guideTempProfile.studying_sunday == this.tempProfile.studying_sunday &&
            this.guideTempProfile.reminders_ok == this.tempProfile.reminders_ok) {
          this.saveInactive = true
        }
        else{
          this.saveInactive = false
        }
      }
      else {
        if(this.profile.datas.studying_monday == this.tempProfile.studying_monday &&
            this.profile.datas.studying_tuesday == this.tempProfile.studying_tuesday &&
            this.profile.datas.studying_wednesday == this.tempProfile.studying_wednesday &&
            this.profile.datas.studying_thursday == this.tempProfile.studying_thursday &&
            this.profile.datas.studying_friday == this.tempProfile.studying_friday &&
            this.profile.datas.studying_saturday == this.tempProfile.studying_saturday &&
            this.profile.datas.studying_sunday == this.tempProfile.studying_sunday &&
            this.profile.datas.reminders_ok == this.tempProfile.reminders_ok) {
          this.saveInactive = true
        }
        else{
          this.saveInactive = false
        }
      }*/
    },

    dayNames: function (id) {
      switch (id) {
        case 0:
          return "Lun"
        case 1:
          return "Mar"
        case 2:
          return "Mer"
        case 3:
          return "Jeu"
        case 4:
          return "Ven"
        case 5:
          return "Sam"
        case 6:
          return "Dim"
        default:
          return "";
      }
    },
    daySelected: function (id) {
      switch (id) {
        case 0:
          return this.tempProfile.studying_monday
        case 1:
          return this.tempProfile.studying_tuesday
        case 2:
          return this.tempProfile.studying_wednesday
        case 3:
          return this.tempProfile.studying_thursday
        case 4:
          return this.tempProfile.studying_friday
        case 5:
          return this.tempProfile.studying_saturday
        case 6:
          return this.tempProfile.studying_sunday
        default:
          return "";
      }
    },

    dayCount: function () {
      let thecount = 0
      for(let i=0; i <=6; i++){
        thecount += this.daySelected(i)
      }
      return thecount
    },

    toggleDay: function (id) {
      this.saveInactive = false;
      switch (id) {
        case 0:
          this.tempProfile.studying_monday = !this.tempProfile.studying_monday;
          break;
        case 1:
          this.tempProfile.studying_tuesday = !this.tempProfile.studying_tuesday;
          break;
        case 2:
          this.tempProfile.studying_wednesday = !this.tempProfile.studying_wednesday;
          break;
        case 3:
          this.tempProfile.studying_thursday = !this.tempProfile.studying_thursday;
          break;
        case 4:
          this.tempProfile.studying_friday = !this.tempProfile.studying_friday;
          break;
        case 5:
          this.tempProfile.studying_saturday = !this.tempProfile.studying_saturday;
          break;
        case 6:
          this.tempProfile.studying_sunday = !this.tempProfile.studying_sunday;
          break;
      }
    },
  },

  watch: {
    'tempProfile.studying_monday':'changedTempProfile',
    'tempProfile.studying_tuesday':'changedTempProfile',
    'tempProfile.studying_wednesday':'changedTempProfile',
    'tempProfile.studying_thursday':'changedTempProfile',
    'tempProfile.studying_friday':'changedTempProfile',
    'tempProfile.studying_saturday':'changedTempProfile',
    'tempProfile.studying_sunday':'changedTempProfile',
    'tempProfile.reminders_ok':'changedTempProfile',
  },


  data() {
    return {
      saveInactive: false,
      tempProfile: {},
      weeklySessionNb: 0,
      messageDisplay: true,
      goals: [
        {
          day: {
            name: 'monday',
            isOn: false
          }
        },
        {
          day: {
            name: 'tuesday',
            isOn: false
          }
        },
        {
          day: {
            name: 'wednesday',
            isOn: false
          }
        },
        {
          day: {
            name: 'thursday',
            isOn: false
          }
        },
        {
          day: {
            name: 'friday',
            isOn: false
          }
        },
        {
          day: {
            name: 'saturday',
            isOn: false
          }
        },
        {
          day: {
            name: 'sunday',
            isOn: false
          },
        },
      ],

      week: {
        0: 'Dim',
        1: 'Lun',
        2: 'Mar',
        3: 'Mer',
        4: 'Jeu',
        5: 'Ven',
        6: 'Sam'
      }
    }
  }
}
</script>

<style scoped>

  .goalcontent{
    display: grid;
    width: 50vw;
    max-width: 50vw;
    height: calc(100% - 2vw);
    max-height: calc(100% - 2vw);
    grid-template-rows: auto auto auto 1fr;
    position: relative;
    grid-gap: 3vw;
    padding: 1vw;
    justify-items: center;
  }
  #setgoalbody{
    width: 100%;
    min-width: 100%;
    display: grid;
    grid-template-rows: 1fr;
    grid-gap: 1vw;
  }
  #nbdaysstudying{
    width:fit-content;
    position: absolute;
    right: 0.25vw;
    top: 0.25vw;
    font-size: 0.9em;
    border: 0.1vw var(--goalBackgroundColor) solid;

  }

  .calendar{
    display: grid;
    grid-template-columns: repeat(7, auto);
    grid-gap: 1vw;
    width: min-content;
  }

  .studyingDay{
    height: 5vw;
    width: 5vw;
    border-radius: 6vw;
    font-size: 1.5em;
    font-weight: bold;
    background-color: rgba(76,76,76,0.27);
  }

  .selected{
    background-color: var(--goalBackgroundColor);
    color: var(--goalColor);
  }

  .message {
    height: 100%;
    display: grid;
    grid-template-rows: 3fr 1fr;
  }

  @media screen and (max-device-width: 767px) {
    .goalcontent{
      width: calc(100% - 8vw);
      max-width: calc(100% - 8vw);
      height: 90%;
      max-height: 90%;
      grid-gap: 4vw;
      justify-self: center;
      padding: 4vw;
    }

    .calendar{
      grid-gap: 4vw;
      grid-template-columns: repeat(4, auto);
      grid-template-rows: 1fr 1fr;
      padding: 1.5vw;
    }

    .studyingDay{
      height: 15vw;
      width: 15vw;
      border-radius: 12vw;
    }
  }
</style>